type Props = {
  value: number;
  max?: number;
  className?: string;
  barClassName?: string;
};

export function Progress({ value, max = 100, className = "", barClassName = "bg-brand-500" }: Props) {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <div className={`h-1.5 rounded-full bg-ink-100 dark:bg-ink-800 overflow-hidden ${className}`}>
      <div className={`h-full ${barClassName}`} style={{ width: `${pct}%` }} />
    </div>
  );
}
